var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Clock50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00acc1",
    d: "M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M40,24c0,8.838-7.162,16-16,16S8,32.838,8,24S15.163,8,24,8S40,15.163,40,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#78909c",
    d: "M23 39.95C23.332 39.97 23.662 40 24 40s.668-.03 1-.05V36h-2V39.95zM36 25h3.95C39.97 24.668 40 24.338 40 24s-.03-.668-.05-1H36V25zM8.05 25H12v-2H8.05C8.03 23.332 8 23.662 8 24S8.03 24.668 8.05 25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.664,30.27L29.934,32l-6.797-6.797l1.73-1.73L31.664,30.27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27,24c0,1.656-1.344,3-3,3s-3-1.344-3-3s1.344-3,3-3S27,22.344,27,24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11h2v10.336h-2V11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00acc1",
    d: "M25,24c0,0.551-0.449,1-1,1s-1-0.449-1-1s0.449-1,1-1S25,23.449,25,24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Clock50);
export default __webpack_public_path__ + "static/media/icons8-clock-50.96c77b78356c97d7265fa05425d5e41c.svg";
export { ForwardRef as ReactComponent };